module.exports = __webpack_public_path__ + "img/core-active-1.b938947.svg";